import React from "react";
import { FaBriefcase } from "react-icons/fa";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

const Experience = () => {
  return (
    <div
      name="experience"
      className="w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Experience
          </p>
        </div>
        <VerticalTimeline lineColor="#3e497a">
          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            date="2014 - 2018"
            iconStyle={{ background: "#3e497a", color: "#fff" }}
            icon={<FaBriefcase />}
          >
            <h3
              className="vertical-timeline-element-title"
              style={{ color: "gray", fontWeight: 700 }}
            >
              Ariveguru Technology Solutions Pvt ltd.
            </h3>

            <h4
              className="vertical-timeline-element-subtitle"
              style={{ color: "gray", fontWeight: 500 }}
            >
              Full Stack Engineer
            </h4>

            <p style={{ color: "gray", fontWeight: 400 }}>07/2019 - 03/2021 </p>
          </VerticalTimelineElement>
          {/* <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2018 - 2020"
          iconStyle={{ background: "#e9d35b", color: "#fff" }}
          icon={<FaBriefcase />}
        >
          <h3 className="vertical-timeline-element-title">
            Back End Engineer - Google
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            San Francisco, CA
          </h4>
          <p>Developed the backend infrastructure for 3 projects.</p>
        </VerticalTimelineElement> */}

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2020 - present"
            iconStyle={{ background: "#e9d35b", color: "#fff" }}
            icon={<FaBriefcase />}
          >
            <h3
              className="vertical-timeline-element-title"
              style={{ color: "gray", fontWeight: 700 }}
            >
              Tricog Health India Pvt. Ltd.
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              style={{ color: "gray", fontWeight: 500 }}
            >
              Full Stack Engineer
            </h4>
            <p style={{ color: "gray", fontWeight: 400 }}>04/2021 - present</p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
};

export default Experience;
